export default "__VITE_ASSET__DIXolCRp__"